import React from "react";

function EditIcon() {
  return (
    <span className="anticon ant-edit">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M14.437 0c.655 0 1.283.261 1.741.723l3.101 3.101a2.461 2.461 0 010 3.481L7.958 18.625c-.699.805-1.69 1.3-2.823 1.378H0v-1l.003-4.215c.085-1.054.576-2.035 1.323-2.694L12.696.726a2.452 2.452 0 011.741-.725zm-4.135 5.945L2.696 13.55c-.405.358-.656.86-.696 1.318v3.135l3.064.002c.534-.038 1.031-.287 1.43-.743l7.562-7.563-3.754-3.754zM14.437 2a.456.456 0 00-.323.135l-2.398 2.396 3.754 3.754 2.395-2.393a.465.465 0 000-.653l-3.104-3.104A.458.458 0 0014.437 2z"
        ></path>
      </svg>
    </span>
  );
}

export default EditIcon;
